<template>
  <div class="page-card exposure-page">
    <div class="page-head">
      <h2 class="page-title">通告曝光配置</h2>
      <el-button type="primary" @click="fetchData">刷新</el-button>
    </div>

    <el-card class="section-card" shadow="never">
      <div slot="header" class="section-header">
        <span>兑换比例</span>
        <el-button type="primary" size="small" @click="saveConfig">保存</el-button>
      </div>
      <el-form :inline="true" :model="configForm">
        <el-form-item label="1元兑换曝光值">
          <el-input-number v-model="configForm.yuanToExposureRatio" :min="1" :precision="0" />
        </el-form-item>
        <el-form-item label="更新时间">
          <span>{{ config.updatedAt || '-' }}</span>
        </el-form-item>
      </el-form>
    </el-card>

    <el-card class="section-card" shadow="never">
      <div slot="header" class="section-header">
        <span>人工调整曝光值</span>
        <el-button type="primary" size="small" @click="submitAdjust">提交调整</el-button>
      </div>
      <el-form :model="adjustForm" label-width="100px" class="adjust-form">
        <el-form-item label="选择通告">
          <el-select
            v-model="adjustForm.noticeId"
            filterable
            remote
            clearable
            reserve-keyword
            placeholder="搜索通告名称/编号/ID"
            :remote-method="searchNotices"
            :loading="noticeLoading"
            @change="handleNoticeChange"
          >
            <el-option
              v-for="item in noticeOptions"
              :key="item.id"
              :label="noticeOptionLabel(item)"
              :value="item.id"
            />
          </el-select>
          <div class="field-tip">可从下拉选择通告，也可直接在下方输入通告ID。</div>
        </el-form-item>
        <el-form-item label="通告ID">
          <el-input
            v-model.trim="adjustForm.noticeId"
            placeholder="请输入通告ID"
            @blur="syncNoticeById"
          />
        </el-form-item>
        <el-form-item label="通告名称">
          <span>{{ selectedNoticeTitle || '-' }}</span>
        </el-form-item>
        <el-form-item label="调整值">
          <el-input-number v-model="adjustForm.changeValue" :precision="0" />
        </el-form-item>
        <el-form-item label="原因">
          <el-input v-model="adjustForm.reason" placeholder="请输入调整原因" />
        </el-form-item>
      </el-form>
    </el-card>

    <el-card class="section-card" shadow="never">
      <div slot="header" class="section-header">
        <span>充值流水</span>
        <div class="filters">
          <el-input v-model="filters.merchantUserId" clearable placeholder="商家ID" size="small" />
          <el-input v-model="filters.noticeId" clearable placeholder="通告ID" size="small" />
          <el-button size="small" @click="fetchRecords(true)">查询</el-button>
        </div>
      </div>
      <el-table :data="records" border>
        <el-table-column prop="rechargeNo" label="充值单号" min-width="180" />
        <el-table-column prop="merchantUserId" label="商家ID" width="110" />
        <el-table-column prop="merchantName" label="商家" min-width="150" />
        <el-table-column prop="noticeId" label="通告ID" width="110" />
        <el-table-column prop="noticeTitle" label="通告" min-width="180" />
        <el-table-column prop="amount" label="金额" width="100" />
        <el-table-column prop="exchangeRatio" label="比例" width="90" />
        <el-table-column prop="exposureValue" label="增加曝光" width="110" />
        <el-table-column prop="beforeValue" label="充值前" width="100" />
        <el-table-column prop="afterValue" label="充值后" width="100" />
        <el-table-column prop="createdAt" label="时间" width="170" />
      </el-table>
      <el-pagination
        class="table-pagination"
        layout="total, prev, pager, next"
        :current-page="recordPagination.page"
        :page-size="recordPagination.pageSize"
        :total="recordPagination.total"
        @current-change="handleRecordPageChange"
      />
    </el-card>

    <el-card class="section-card" shadow="never">
      <div slot="header" class="section-header">
        <span>人工调整记录</span>
        <div class="filters">
          <el-input v-model="adjustFilters.merchantUserId" clearable placeholder="商家ID" size="small" />
          <el-input v-model="adjustFilters.noticeId" clearable placeholder="通告ID" size="small" />
          <el-button size="small" @click="fetchAdjustRecords(true)">查询</el-button>
        </div>
      </div>
      <el-table :data="adjustRecords" border>
        <el-table-column prop="id" label="记录ID" width="100" />
        <el-table-column prop="merchantUserId" label="商家ID" width="110" />
        <el-table-column prop="merchantName" label="商家" min-width="150" />
        <el-table-column prop="noticeId" label="通告ID" width="110" />
        <el-table-column prop="noticeTitle" label="通告" min-width="180" />
        <el-table-column label="调整值" width="110">
          <template slot-scope="{ row }">
            <span :class="{ positive: Number(row.changeValue) > 0, negative: Number(row.changeValue) < 0 }">
              {{ signedValue(row.changeValue) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="beforeValue" label="调整前" width="100" />
        <el-table-column prop="afterValue" label="调整后" width="100" />
        <el-table-column prop="adminName" label="操作人" width="120" />
        <el-table-column prop="reason" label="原因" min-width="180" show-overflow-tooltip />
        <el-table-column prop="createdAt" label="时间" width="170" />
      </el-table>
      <el-pagination
        class="table-pagination"
        layout="total, prev, pager, next"
        :current-page="adjustPagination.page"
        :page-size="adjustPagination.pageSize"
        :total="adjustPagination.total"
        @current-change="handleAdjustPageChange"
      />
    </el-card>
  </div>
</template>

<script>
import {
  adjustNoticeExposure,
  getNoticeExposureAdjustRecords,
  getNoticeExposureConfig,
  getNoticeExposureNotices,
  getNoticeExposureRecharges,
  saveNoticeExposureConfig
} from '../../../api/platformManage'

export default {
  name: 'NoticeExposurePage',
  data() {
    return {
      config: {},
      configForm: {
        yuanToExposureRatio: 100
      },
      adjustForm: {
        noticeId: '',
        changeValue: 0,
        reason: ''
      },
      filters: {
        merchantUserId: '',
        noticeId: ''
      },
      adjustFilters: {
        merchantUserId: '',
        noticeId: ''
      },
      noticeLoading: false,
      noticeOptions: [],
      selectedNoticeTitle: '',
      records: [],
      adjustRecords: [],
      recordPagination: {
        page: 1,
        pageSize: 5,
        total: 0
      },
      adjustPagination: {
        page: 1,
        pageSize: 5,
        total: 0
      }
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    async fetchData() {
      await Promise.all([this.fetchConfig(), this.fetchRecords(), this.fetchAdjustRecords(), this.searchNotices('')])
    },
    async fetchConfig() {
      this.config = await getNoticeExposureConfig()
      this.configForm.yuanToExposureRatio = Number(this.config.yuanToExposureRatio || 100)
    },
    async fetchRecords(resetPage = false) {
      if (resetPage) {
        this.recordPagination.page = 1
      }
      const params = {
        page: this.recordPagination.page,
        pageSize: this.recordPagination.pageSize
      }
      if (this.filters.merchantUserId) params.merchantUserId = this.filters.merchantUserId
      if (this.filters.noticeId) params.noticeId = this.filters.noticeId
      const data = await getNoticeExposureRecharges(params)
      this.records = this.extractPageRecords(data)
      this.recordPagination.total = this.extractPageTotal(data, this.records.length)
    },
    async fetchAdjustRecords(resetPage = false) {
      if (resetPage) {
        this.adjustPagination.page = 1
      }
      const params = {
        page: this.adjustPagination.page,
        pageSize: this.adjustPagination.pageSize
      }
      if (this.adjustFilters.merchantUserId) params.merchantUserId = this.adjustFilters.merchantUserId
      if (this.adjustFilters.noticeId) params.noticeId = this.adjustFilters.noticeId
      const data = await getNoticeExposureAdjustRecords(params)
      this.adjustRecords = this.extractPageRecords(data)
      this.adjustPagination.total = this.extractPageTotal(data, this.adjustRecords.length)
    },
    extractPageRecords(data) {
      if (Array.isArray(data)) {
        return data
      }
      return data && Array.isArray(data.records) ? data.records : []
    },
    extractPageTotal(data, fallbackTotal) {
      if (Array.isArray(data)) {
        return fallbackTotal
      }
      return data && data.total != null ? Number(data.total) : fallbackTotal
    },
    handleRecordPageChange(page) {
      this.recordPagination.page = page
      this.fetchRecords()
    },
    handleAdjustPageChange(page) {
      this.adjustPagination.page = page
      this.fetchAdjustRecords()
    },
    async searchNotices(keyword) {
      this.noticeLoading = true
      try {
        const data = await getNoticeExposureNotices({
          keyword: keyword || undefined
        })
        this.noticeOptions = Array.isArray(data) ? data : []
        this.updateSelectedNoticeTitle()
      } finally {
        this.noticeLoading = false
      }
    },
    noticeOptionLabel(item) {
      const title = item.title || '未命名通告'
      const noticeNo = item.noticeNo ? ` | ${item.noticeNo}` : ''
      return `${title}（ID：${item.id}${noticeNo}）`
    },
    handleNoticeChange() {
      this.updateSelectedNoticeTitle()
    },
    async syncNoticeById() {
      if (!this.adjustForm.noticeId) {
        this.selectedNoticeTitle = ''
        return
      }
      const exists = this.noticeOptions.some(item => String(item.id) === String(this.adjustForm.noticeId))
      if (!exists) {
        await this.searchNotices(this.adjustForm.noticeId)
      }
      this.updateSelectedNoticeTitle()
    },
    updateSelectedNoticeTitle() {
      const selected = this.noticeOptions.find(item => String(item.id) === String(this.adjustForm.noticeId))
      this.selectedNoticeTitle = selected ? selected.title : ''
    },
    getSelectedNotice() {
      return this.noticeOptions.find(item => String(item.id) === String(this.adjustForm.noticeId)) || null
    },
    async saveConfig() {
      await saveNoticeExposureConfig(this.configForm)
      this.$message.success('兑换比例已保存')
      await this.fetchConfig()
    },
    async submitAdjust() {
      if (!this.adjustForm.noticeId || !this.adjustForm.changeValue) {
        this.$message.warning('请填写通告ID和调整值')
        return
      }
      const selectedNotice = this.getSelectedNotice()
      if (!selectedNotice || Number(selectedNotice.status) !== 5) {
        this.$message.warning('仅支持选择招募中的通告')
        return
      }
      await adjustNoticeExposure({
        noticeId: String(this.adjustForm.noticeId),
        changeValue: Number(this.adjustForm.changeValue),
        reason: this.adjustForm.reason
      })
      this.$message.success('曝光值已调整')
      this.adjustForm = { noticeId: '', changeValue: 0, reason: '' }
      this.selectedNoticeTitle = ''
      this.adjustPagination.page = 1
      await Promise.all([this.fetchRecords(), this.fetchAdjustRecords(), this.searchNotices('')])
    },
    signedValue(value) {
      const numericValue = Number(value || 0)
      return numericValue > 0 ? `+${numericValue}` : String(numericValue)
    }
  }
}
</script>

<style scoped>
.page-head,
.section-header,
.filters {
  display: flex;
  align-items: center;
}

.page-head,
.section-header {
  justify-content: space-between;
}

.section-card {
  margin-top: 18px;
}

.filters {
  gap: 8px;
}

.filters .el-input {
  width: 130px;
}

.table-pagination {
  margin-top: 16px;
  text-align: right;
}

.adjust-form {
  max-width: 720px;
}

.adjust-form .el-select,
.adjust-form .el-input {
  width: 360px;
}

.field-tip {
  margin-top: 6px;
  color: #909399;
  font-size: 12px;
  line-height: 18px;
}

.positive {
  color: #67c23a;
  font-weight: 700;
}

.negative {
  color: #f56c6c;
  font-weight: 700;
}
</style>
